import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZimbabwe = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1835)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.8515 6.872C22.2418 5.58416 21.4097 4.42245 20.4047 3.43597L12.0001 2.60867L3.59537 3.43602C3.56856 3.46231 3.5424 3.48922 3.51587 3.5158L6.87212 6.87205L12.0001 7.02866L22.8515 6.872Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51569 20.4843C3.55984 20.5285 3.6039 20.5727 3.64872 20.6162L12 21.3913L20.3512 20.6162C21.3666 19.6318 22.2088 18.47 22.8271 17.1801L7.30431 16.6956C5.9687 18.0313 4.4282 19.5717 3.51569 20.4843Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.8807 10.308L9.91302 9.91302L12 12C11.3819 12.6181 10.4591 13.5409 9.91302 14.087L23.8733 13.7441C23.9563 13.1746 24 12.5924 24 12C24 11.4256 23.9587 10.8609 23.8807 10.308Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C8.7268 0 5.76027 1.31109 3.59531 3.43603H20.4047C18.2397 1.31109 15.2732 0 12 0Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3081 10.308H23.8807C23.7094 9.09496 23.3571 7.94024 22.8514 6.87201H6.87204L10.3081 10.308Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.81985 17.1801H22.8271C23.3387 16.1127 23.6966 14.9578 23.8734 13.7441H10.2559C8.92525 15.0748 7.79753 16.2025 6.81985 17.1801Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C15.2463 24 18.191 22.7104 20.3512 20.6161H3.6488C5.80899 22.7104 8.75368 24 12 24Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.28507 2.80942C4.0183 3.03357 3.76091 3.26856 3.51468 3.5147L12 12L3.51468 20.4853C3.76087 20.7315 4.0183 20.9665 4.28507 21.1906L13.4757 12L4.28507 2.80942Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.82461 8.86954L5.60156 11.2609H8.11617L6.08189 12.739L6.85889 15.1304L4.82461 13.6524L2.79028 15.1304L3.56738 12.739L1.53314 11.2609H4.04761L4.82461 8.86954Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.96181 12.1957L4.93691 11.4783C4.93691 11.4783 4.78728 10.0747 4.77823 10.0271C4.70952 9.66512 4.39138 9.39133 4.00934 9.39133C3.57716 9.39133 3.22672 9.74172 3.22672 10.174C3.22672 10.2456 3.23717 10.3147 3.25522 10.3807L2.68747 10.9522H3.69697C3.69697 12 2.91509 12 2.91509 13.0435L3.34883 14.087H5.95752L6.39233 13.0435H6.39214C6.43569 12.9434 6.46213 12.8401 6.47305 12.7369C6.84786 12.5853 6.96181 12.1957 6.96181 12.1957Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1835",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgZimbabwe;
